import { useQuery } from '@apollo/client';
import { STUDIOS_IDS_BY_USER_ID } from '../graphql/queries/queries';

export const useFetchUserStudiosIds = (userId) => {
  const { data, loading, error } = useQuery(STUDIOS_IDS_BY_USER_ID, {
    variables: { 
      userID: userId,
    },
    fetchPolicy: 'cache-and-network',
  });

  return {
    data,
    loading,
    error
  };
};